import type { EndScreenConfig } from '../types'
import styles from './EndScreen.module.css'

interface Props {
  visible: boolean
  config?: EndScreenConfig
  onReplay: () => void
}

export function EndScreen({ visible, config, onReplay }: Props) {
  if (!visible) return null
  return (
    <div className={styles.wrap}>
      <button type="button" className={styles.replay} onClick={onReplay}>
        Replay
      </button>
      <div className={styles.grid}>
        {config?.next && (
          <a className={styles.card} href={config.next.href || '#'}>
            {config.next.poster && <img src={config.next.poster} alt="" />}
            <span>Up next</span>
            <strong>{config.next.title}</strong>
          </a>
        )}
        {(config?.related || []).map((item) => (
          <a key={item.title} className={styles.card} href={item.href || '#'}>
            {item.poster && <img src={item.poster} alt="" />}
            <strong>{item.title}</strong>
          </a>
        ))}
      </div>
    </div>
  )
}
